import FsLightbox from 'fslightbox';

/**
 * File lightbox.js
 * Adds lightbox to Wordpress gallery blocks.
 */
document.querySelectorAll('.wp-block-gallery img').forEach(function(image)
{
    if (image.hasAttribute('srcset')) {

        const srcset = image.getAttribute("srcset").split(", ");
        const src = srcset[srcset.length - 1].split(" ")[0];

        const href = document.createElement("a");
        href.setAttribute("href", src);
        href.setAttribute("data-fslightbox", "galerija");

        image.parentNode.insertBefore(href, image);
        href.appendChild(image);
    }
});

refreshFsLightbox();